import angular from 'angular';

angular
    .module('principal')

    .factory('PrincipalService', [
        '$resource',
        'CONF',
        'API_CONFIG',
        function ($resource, CONF, API_CONFIG) {
            var Principal = $resource(
                API_CONFIG.url + '/v1/principal',
                {},
                {
                    // Création d'un donneur d'ordre
                    create: { method: 'POST' },
                    // Liste de tous les donneurs d'ordres suivant des critères
                    getPrincipals: {
                        method: 'POST',
                        url: CONF.apiContext + CONF.apiBaseUrl + '/v1/principals/findByCriterias',
                        isArray: true,
                    },
                    // Compte le nombre de sociétés et de containers
                    countCompanyContainer: {
                        method: 'POST',
                        url: API_CONFIG.url + '/v1/principal/countCompanyContainer',
                        isArray: true,
                    },
                    // Liste tous les DO.
                    findAll: {
                        method: 'GET',
                        url: API_CONFIG.url + '/v1/principal',
                        isArray: true,
                    },
                    get: {
                        method: 'GET',
                        url: API_CONFIG.url + '/v1/principal/:principalId',
                    },
                    // Import d'un DO
                    import: { method: 'POST' },
                }
            );

            // Ajout de la propriété fullname
            Object.defineProperty(Principal.prototype, 'fullname', {
                get: function () {
                    return this.principalId + ', ' + this.principalName;
                },
            });
            // Ajout de la propriété EidWithID
            Object.defineProperty(Principal.prototype, 'eidWithId', {
                get: function () {
                    return this.principalEid + ' (' + this.principalAppId + ')';
                },
            });

            return Principal;
        },
    ]);
